
import { RedirectionRule } from './types';

export const getDefaultRedirectionRules = (): RedirectionRule[] => [
  // Redirections pour les anciennes URLs
  {
    from: '/services',
    to: '/nos-services',
    type: '301',
    reason: 'Ancienne structure d\'URL'
  },
  {
    from: '/location-benne',
    to: '/nos-services/location-bennes',
    type: '301',
    reason: 'Ancienne URL de service'
  },
  {
    from: '/achat-metaux',
    to: '/nos-services/achat-metaux',
    type: '301',
    reason: 'Ancienne URL de service'
  },
  {
    from: '/demo',
    to: '/nos-services/demolition',
    type: '301',
    reason: 'URL raccourcie obsolète'
  },
  {
    from: '/contact.html',
    to: '/contact',
    type: '301',
    reason: 'Migration vers SPA'
  },
  {
    from: '/index.html',
    to: '/',
    type: '301',
    reason: 'Migration vers SPA'
  },
  // Redirections spécifiques pour tous les sites - UUID vers vraies URLs avec vraies villes
  {
    from: '/sites/7f40171c-4507-4cec-95d5-d621b4a4deea',
    to: '/site/belle-recyclage/sainte-radegonde',
    type: '301',
    reason: 'URL optimisée SEO Bellé Recyclage avec vraie ville'
  },
  {
    from: '/sites/belle-recyclage',
    to: '/site/belle-recyclage/sainte-radegonde',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/1bbf24f6-47e9-49e6-acce-ee49c487c3e3',
    to: '/site/briane-jean-recuperation/ledergues',
    type: '301',
    reason: 'URL optimisée SEO Briane Jean avec vraie ville'
  },
  {
    from: '/sites/briane-jean-recuperation',
    to: '/site/briane-jean-recuperation/ledergues',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/f151588c-e129-4bfc-be02-69240ed00223',
    to: '/site/carmausine-de-recuperation/carmaux',
    type: '301',
    reason: 'URL optimisée SEO Carmausine avec vraie ville'
  },
  {
    from: '/sites/carmausine-recuperation',
    to: '/site/carmausine-de-recuperation/carmaux',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/5241f80d-9340-4513-b210-5bc29e1cb54e',
    to: '/site/casse-auto-du-bassin/viviez',
    type: '301',
    reason: 'URL optimisée SEO Casse Auto avec vraie ville'
  },
  {
    from: '/sites/casse-auto-bassin',
    to: '/site/casse-auto-du-bassin/viviez',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/6276bdc7-5aac-477c-8859-a48b84267d89',
    to: '/site/fabrude-recyclage/saint-paul-des-landes',
    type: '301',
    reason: 'URL optimisée SEO Fabrude avec vraie ville'
  },
  {
    from: '/sites/fabrude-recyclage',
    to: '/site/fabrude-recyclage/saint-paul-des-landes',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/d0e83661-3827-4de3-91b5-24b65fe092f9',
    to: '/site/lescout-recyclage/lescout',
    type: '301',
    reason: 'URL optimisée SEO Lescout avec vraie ville'
  },
  {
    from: '/sites/lescout-recyclage',
    to: '/site/lescout-recyclage/lescout',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/d6d6fc33-504b-438d-8b93-209e4f218772',
    to: '/site/profit-recyclage/beauchamp',
    type: '301',
    reason: 'URL optimisée SEO Profit avec vraie ville'
  },
  {
    from: '/sites/profit-recyclage',
    to: '/site/profit-recyclage/beauchamp',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  {
    from: '/sites/f73b630e-b9c6-4e63-b7c6-04af2ff572c3',
    to: '/site/rm-recyclage/coren',
    type: '301',
    reason: 'URL optimisée SEO RM Recyclage avec vraie ville'
  },
  {
    from: '/sites/rm-recyclage',
    to: '/site/rm-recyclage/coren',
    type: '301',
    reason: 'Mise à jour vers URL avec vraie ville'
  },
  // Redirections géographiques
  {
    from: '/bennes-aveyron',
    to: '/nos-services/location-bennes/aveyron',
    type: '301',
    reason: 'Standardisation géographique'
  },
  {
    from: '/metaux-toulouse',
    to: '/nos-services/achat-metaux/haute-garonne',
    type: '301',
    reason: 'Standardisation géographique'
  }
];
